var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        [
          _c(
            "el-row",
            {
              staticStyle: { "flex-wrap": "wrap", "align-items": "end" },
              attrs: { type: "flex", justify: "left" },
            },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "日期(Data)" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "95%" },
                        attrs: {
                          clearable: false,
                          "end-placeholder": "结束时间（Hora de fim）",
                          "range-separator": "-",
                          "start-placeholder": "开始时间（Hora de início）",
                          type: "daterange",
                          "value-format": "yyyy-MM-dd",
                          size: "small",
                        },
                        on: { change: _vm.dateChange },
                        model: {
                          value: _vm.timeValue,
                          callback: function ($$v) {
                            _vm.timeValue = $$v
                          },
                          expression: "timeValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "大区(Região)" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "95%" },
                          attrs: {
                            placeholder: "请选择(Favor selecionar)",
                            clearable: "",
                            filterable: "",
                            multiple: "",
                            "collapse-tags": "",
                            size: "small",
                          },
                          on: { change: _vm.changeRegion },
                          model: {
                            value: _vm.queryForm.regionIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "regionIds", $$v)
                            },
                            expression: "queryForm.regionIds",
                          },
                        },
                        _vm._l(_vm.regionList, function (item, idx) {
                          return _c("el-option", {
                            key: idx,
                            attrs: {
                              label: item.zhName + "（" + item.puName + "）",
                              value: item.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "州(UF)" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "95%" },
                          attrs: {
                            placeholder: "请选择(Favor selecionar)",
                            clearable: "",
                            filterable: "",
                            multiple: "",
                            "multiple-limit": 50,
                            "collapse-tags": "",
                            size: "small",
                          },
                          model: {
                            value: _vm.queryForm.states,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "states", $$v)
                            },
                            expression: "queryForm.states",
                          },
                        },
                        _vm._l(_vm.StateList, function (item, idx) {
                          return _c("el-option", {
                            key: idx,
                            attrs: { label: item.label, value: item.label },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", plain: "", size: "small" },
              on: { click: _vm.search },
            },
            [_vm._v("查询(Consultar)")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.exportAll },
            },
            [_vm._v("导出(Exportar)")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            border: "",
            "max-height": "600",
            "span-method": _vm.objectSpanMethod,
            "summary-method": _vm.getSummaries,
            "row-class-name": _vm.tableRowClassName,
            "cell-class-name": _vm.cellClassName,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: "序号(No.)",
              align: "center",
              width: "60",
            },
          }),
          _vm._l(_vm.tableHeaderList, function (item, idx) {
            return _c("el-table-column", {
              key: idx,
              attrs: {
                align: "center",
                label: item.label,
                "min-width": item.cloWidth,
                prop: item.prop,
                "show-overflow-tooltip": false,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        item.prop === "lostCount" ||
                        item.prop === "damagedCount" ||
                        item.prop === "lossCount" ||
                        item.prop === "stolenCount"
                          ? _c("div", [
                              scope.row[item.prop]
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#1990ff",
                                        cursor: "pointer",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toDetail(
                                            scope.row,
                                            item.prop
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(scope.row[item.prop]) + " "
                                      ),
                                    ]
                                  )
                                : _c("span", [_vm._v("--")]),
                            ])
                          : _c("div", [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    scope.row[item.prop]
                                      ? "" + scope.row[item.prop]
                                      : "--"
                                  )
                                ),
                              ]),
                            ]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }